import { useEffect, useState } from "react"
import { FieldValues, UseFormReturn } from "react-hook-form"

export type StoreFormState = {
  isDirty: boolean
  isSubmitted: boolean
  hasErrors: boolean
}

export const useStoreFormState = <TFieldValue extends FieldValues>(storeForm?: UseFormReturn<TFieldValue>) => {
  const [storeFormState, setStoreFormState] = useState<StoreFormState>({
    isDirty: false,
    isSubmitted: false,
    hasErrors: false,
  })

  useEffect(() => {
    if (storeForm) {
      if (storeForm.formState.isDirty) {
        setStoreFormState((state) => {
          return { ...state, isDirty: true }
        })
      }

      if (storeForm.formState.isSubmitted) {
        setStoreFormState((state) => {
          return { ...state, isSubmitted: true }
        })
      }
      if (Object.keys(storeForm?.formState?.errors).length > 0) {
        setStoreFormState((state) => {
          return { ...state, hasErrors: true }
        })
      }
    }
  }, [storeForm, setStoreFormState])

  return storeFormState
}
